/**
 * Provider and one-line description shown next to each model checkbox on the admin account page.
 * Keyed by the feature string (= monitor type name); a model missing here still renders, just bare.
 */
export const MODEL_CATALOG: Record<string, { provider: string; description: string }> = {
  GPT_SEARCH_BROWSER: {
    provider: 'OpenAI',
    description: 'GPT Search — ChatGPT answers with web search.',
  },
  GPT_API_BROWSER: { provider: 'OpenAI', description: 'GPT API Search — GPT via API with web search.' },
  GEMINI_API: { provider: 'Google', description: 'Gemini via API.' },
  CLAUDE_API: {
    provider: 'Anthropic',
    description: 'Claude via API (web search with the CLAUDE_WEB addon).',
  },
  DEEP_SEEK_API: { provider: 'DeepSeek', description: 'DeepSeek via API.' },
  PERPLEXITY_API: { provider: 'Perplexity', description: 'Perplexity API Search.' },
  PERPLEXITY_SEARCH_BROWSER: {
    provider: 'Perplexity',
    description: 'Perplexity Search (web UI channel).',
  },
  GROK_API: { provider: 'xAI', description: 'Grok via API.' },
  AI_OVERVIEW: {
    provider: 'Google',
    description: 'Legacy AI Overview channel (replaced by AI_OVERVIEW_NEW).',
  },
  AI_OVERVIEW_NEW: { provider: 'Google', description: 'Google AI Overview on the search results page.' },
  AI_MODE: { provider: 'Google', description: 'Google AI Mode.' },
  GROK_SEARCH_BROWSER: { provider: 'xAI', description: 'Grok Search — Grok with web search.' },
  COPILOT_SEARCH_BROWSER: { provider: 'Microsoft', description: 'Microsoft Copilot search.' },
  GEMINI_SEARCH_BROWSER: { provider: 'Google', description: 'Gemini Search — Gemini with web search.' },
};
